import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { CheckIcon, LockIcon } from './icons/Icons';
const HERO_BG = 'https://cdn.magicpatterns.com/patterns/generated-images/d8d10b79-d465-4647-bd26-634d9e411ccb.jpg';
const PRODUCT = 'https://cdn.magicpatterns.com/uploads/7T58E3TjTYgiqrvh4HrvYf/G-smart.png';
const qualifiers = ['Comida real que ya conoces', 'Protocolo claro de 21 días', 'Diseñado para mujeres ocupadas'];
export function Hero() {
  return <header className="relative w-full overflow-hidden" data-id="element-173" data-mp="xaxfboi3nqll">
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: `url(${HERO_BG})`
    }} aria-hidden="true" data-id="element-174" data-mp="sartioyigybf" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#f7f4ec]/75 via-[#f7f4ec]/90 to-[#f7f4ec]" aria-hidden="true" data-id="element-175" data-mp="neaugzprwzjk" />

      <div className="relative mx-auto flex max-w-4xl flex-col items-center px-5 py-14 text-center sm:py-20" data-id="element-176" data-mp="3825y4q50c7ld">
        <Reveal data-id="element-177" data-mp="3j9kazboofhg4">
          <p className="max-w-2xl text-xs font-extrabold uppercase tracking-[0.18em] text-[#3d443f] sm:text-sm" data-id="element-178" data-mp="3j923tk0h7itf">
            Para mujeres que están cansadas de vivir con ardor, reflujo y miedo a comer
          </p>
        </Reveal>

        <Reveal delay={0.06} data-id="element-179" data-mp="39cpfz2rm3z6l">
          <h1 className="mt-5 font-display text-4xl font-black leading-[1.04] tracking-tight text-[#292f2b] sm:text-5xl lg:text-6xl" data-id="element-180" data-mp="3e8mtl1bhqrfo">
            Apaga el Fuego de tu{' '}
            <span className="relative inline-block text-[#698b68]" data-id="element-181" data-mp="358reiletecad">
              Gastritis
              <motion.span aria-hidden="true" initial={{
              scaleX: 0
            }} animate={{
              scaleX: 1
            }} transition={{
              delay: 0.55,
              duration: 0.65,
              ease: 'easeOut'
            }} className="absolute -bottom-1 left-0 h-2 w-full origin-left bg-[#b9d0ad]/55" data-id="element-182" data-mp="35akifsy1mieo" />
            </span>{' '}
            en 48 Horas con 3 Alimentos que Ya Tienes en tu Despensa
          </h1>
        </Reveal>

        <Reveal delay={0.12} data-id="element-183" data-mp="s2tenov66frb">
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-[#505c53] sm:text-xl" data-id="element-184" data-mp="s44ghj521dfs">
            Sin antiácidos que te tienen atrapada, sin dietas imposibles y sin gastar una fortuna en especialistas. El método natural que ya usan miles de mujeres para volver a comer tranquilas.
          </p>
        </Reveal>

        <Reveal delay={0.16} data-id="element-185" data-mp="1b0vzrskljsju">
          <ul className="mt-6 flex flex-col items-center gap-2 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-5" data-id="element-186" data-mp="1azuktd0gmlwu">
            {qualifiers.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-[#3d4a40]" data-id="element-187" data-mp="112pur23hu6ar">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#698b68] text-white" data-id="element-188" data-mp="x14ldqq64a5b">
                  <CheckIcon className="h-3 w-3" strokeWidth={3} data-id="element-189" data-mp="3ltgndrclksov" />
                </span>
                {item}
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.2} className="flex justify-center" data-id="element-190" data-mp="1x9b3owgzwtag">
          <motion.div initial={{
          opacity: 0,
          scale: 0.94,
          rotate: -2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          delay: 0.25,
          duration: 0.65,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative mt-9" data-id="element-191" data-mp="1xavy8m3b8c8b">
            <motion.div whileInView={{
            y: [0, -10, 0]
          }} viewport={{
            amount: 0.2
          }} transition={{
            duration: 4.5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-192" data-mp="2b1rbeakudfhp">
              <div className="absolute -inset-6 rounded-[2rem] bg-[#698b68]/12 blur-2xl" aria-hidden="true" data-id="element-193" data-mp="2kxkkfjzcqquq" />
              <img src={PRODUCT} alt="Método GastroSmart, Tu Farmacia en la Despensa" width="1024" height="1024" decoding="async" fetchPriority="high" className="relative w-56 rounded-2xl shadow-2xl sm:w-72" data-id="element-194" data-mp="2p10fibvrwj5b" />
            </motion.div>
          </motion.div>
        </Reveal>

        <Reveal delay={0.26} data-id="element-195" data-mp="49t2nrbsmsra">
          <div className="mt-9 w-full max-w-xl" data-id="element-196" data-mp="4d7672w7180b">
            <CtaButton label="SÍ, QUIERO APAGAR MI ARDOR HOY" price="$10.99" data-id="element-197" data-mp="3vgni4u78vzrw" />
            <p className="mt-3 flex items-center justify-center gap-2 text-xs font-semibold text-[#5a6b5c] sm:text-sm" data-id="element-198" data-mp="ea3g9d1qq26z">
              <LockIcon className="h-4 w-4 text-[#698b68]" strokeWidth={2.2} data-id="element-199" data-mp="9bih7gy85ok4" />
              Acceso inmediato · Garantía blindada de 30 días
            </p>
          </div>
        </Reveal>
      </div>
    </header>;
}